import { render, staticRenderFns } from "./BaseDatepickerInput.vue?vue&type=template&id=1512f925&"
import script from "./BaseDatepickerInput.vue?vue&type=script&lang=js&"
export * from "./BaseDatepickerInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports